import styled from "styled-components";

export const MadaniyWrapper = styled.div``